let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cGMiU")).then(() => parcelRequire('gbo8S'));